import React from 'react';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';
import { Section, Container } from 'components/shared';
import {
  getFieldValue,
  Placeholder,
  RichText,
} from '@sitecore-jss/sitecore-jss-react';

const Title = styled.h3`
  letter-spacing: -0.5px;
  line-height: 2.625rem;

  @media ${breakpoints.md} {
    max-width: 35rem;
  }
`;

const Description = styled.p`
  max-width: 46.25rem;
`;

const Disclaimer = styled.div`
  max-width: 50rem;
`;

const InvestorRelationsForm = ({ fields, rendering }) => {
  const { disclaimer } = fields;
  const headline = getFieldValue(fields, 'headline');
  const description = getFieldValue(fields, 'description');
  const { componentName } = rendering;

  return (
    <Section id={componentName} tabIndex='-1' className='bg-light-blue'>
      <Container>
        <div className='w-full flex flex-col items-center'>
          <Title className='text-mattamy-blue text-center text-4xl font-trade-gothic-20'>
            {headline}
          </Title>

          <Description className='font-graphie text-mattamy-blue text-sm text-center font-light mb-30-mattamy'>
            {description}
          </Description>
        </div>

        <Placeholder name='form-wrapper' rendering={rendering} />
        <Disclaimer
          className='w-full m-auto mt-8 flex items-center font-graphie text-mattamy-blue
            text-sm text-center font-light mb-30-mattamy'
        >
          <RichText tag='p' className='richtext' field={disclaimer} />
        </Disclaimer>
      </Container>
    </Section>
  );
};

export default InvestorRelationsForm;
